import script from "./SkeletItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletItem.vue?vue&type=script&setup=true&lang=js"

import "./SkeletItem.vue?vue&type=style&index=0&id=317d6e0c&lang=scss"

const __exports__ = script;

export default __exports__